/* eslint-disable max-len */
import { SvgIcon } from '@mui/material';
import { CustomSvgIcon } from '@tassat/ui-definitions';
import * as React from 'react';

export default function ExportIcon(props: CustomSvgIcon) {
    const {
        id,
        className,
        iconColor,
        onClick
    } = props;

    return (
        <SvgIcon
            className={className || ''}
            id={id || ''}
            onClick={onClick}
        >
            <svg xmlns='http://www.w3.org/2000/svg'>
                <g>
                    <g
                        id='svg_11'
                        stroke='null'
                    >
                        <g
                            id='svg_5'
                            stroke='null'
                            transform='matrix(0.7190391617376442,0,0,0.8248277074255581,-0.024757136872150087,2.0083351810850525) '
                        >
                            <g
                                fill={iconColor || '#000'}
                                fillRule='nonzero'
                                id='color-'
                            >
                                <path
                                    d='m16.753369,-1.386362a0.88,0.88 0 0 0 -0.48,0.18l-6.29,5.52a0.74,0.74 0 0 0 1,1.11l5,-4.45l0,15.3a0.74,0.74 0 1 0 1.48,0l0,-15.3l5,4.45a0.72,0.72 0 0 0 1,-0.1a0.7,0.7 0 0 0 -0.07,-1l-6.19,-5.53a0.76,0.76 0 0 0 -0.45,-0.18z'
                                    id='svg_8'
                                    stroke='null'
                                />
                                <path
                                    d='m26.473369,21.443638l-19.5,0a0.72,0.72 0 0 1 0,-1.44l19.5,0a0.72,0.72 0 0 1 0,1.44z'
                                    id='svg_9'
                                    stroke='null'
                                />
                                <path
                                    d='m27.053369,25.613638l-20.66,0c-3.11,0 -5.64,-2.06 -5.64,-4.56l0,-4.19a0.72,0.72 0 0 1 1.44,0l0,4.19c0,1.67 1.92,3.09 4.2,3.09l20.66,0c2.28,0 4.2,-1.42 4.2,-3.09l0,-4.19a0.72,0.72 0 1 1 1.44,0l0,4.19c0,2.5 -2.53,4.56 -5.64,4.56z'
                                    id='svg_10'
                                    stroke='null'
                                />
                            </g>
                        </g>
                    </g>
                </g>
            </svg>
        </SvgIcon>
    );
}